import { render } from "./CollaboratorDetail.vue?vue&type=template&id=0d2dbd0e&scoped=true"
import script from "./CollaboratorDetail.vue?vue&type=script&lang=js"
export * from "./CollaboratorDetail.vue?vue&type=script&lang=js"

import "./CollaboratorDetail.vue?vue&type=style&index=0&id=0d2dbd0e&lang=css"
import "./CollaboratorDetail.vue?vue&type=style&index=1&id=0d2dbd0e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2dbd0e"]])

export default __exports__